{
  "action": "Action",
  "allSides": "All Sides",
  "allStatus": "All Status",
  "amount": "Amount",
  "assetsWallet": "Assets / Wallet",
  "available": "Available",
  "availableBalance": "Available Balance",
  "baseCurrency": "Base Currency",
  "buy": "Buy",
  "buyExalt": "Buy EXALT",
  "buyLong": "Buy / Long",
  "buySellTabs": "Buy or sell",
  "buyToken": "Buy Token",
  "cancelOrder": "Cancel Order",
  "cancelOrderFailed": "Cancel order failed.",
  "cancelled": "Cancelled",
  "cancelledOrders": "Cancelled Orders",
  "change24h": "24H Change",
  "close": "Close",
  "completed": "Completed",
  "confirmCancelOrder": "Are you sure you want to cancel this order?",
  "connectWalletFirst": "Connect wallet first.",
  "cost": "Cost",
  "deposits": "Deposits",
  "done": "Done",
  "enterAmount": "Enter Amount",
  "enterPrice": "Enter Price",
  "enterValidAmount": "Please enter a valid amount.",
  "enterValidPrice": "Please enter a valid price.",
  "exportCsv": "Export CSV",
  "failed": "Failed",
  "filled": "Filled",
  "filledOrders": "Filled Orders",
  "filtered": "Filtered",
  "hash": "Hash",
  "high24h": "24H High",
  "installWallet": "Please install MetaMask or Trust Wallet.",
  "instruments": "Instruments",
  "insufficientBalance": "Insufficient balance.",
  "lastPrice": "Last Price",
  "limit": "Limit",
  "limitOrder": "Limit Order",
  "limitPrice": "Limit Price",
  "loadingOrders": "Loading orders...",
  "loadingTrades": "Loading trades...",
  "loadingTransactions": "Loading transactions...",
  "low24h": "24H Low",
  "manageFutures": "Manage Futures",
  "market": "Market",
  "marketOrder": "Market Order",
  "marketOrderNotice": "Market orders execute immediately against currently available liquidity. The execution price may vary, and any unfilled portion will not remain open - it is cancelled immediately, not left resting.",
  "marketPrice": "Market Price",
  "mobileTradingChart": "Mobile Trading Chart",
  "moreOptions": "More Options",
  "noFilledOrders": "No filled orders.",
  "noOpenOrders": "No open orders.",
  "noOrdersFound": "No orders found.",
  "noTradeHistory": "No trade history found.",
  "noTransactionsFound": "No transactions found.",
  "officialExaltContract": "Official EXALT Contract",
  "open": "Open",
  "openOrders": "Open Orders",
  "orderBook": "Order Book",
  "orderCancelledSuccessfully": "Order cancelled successfully.",
  "orderFailed": "Order failed.",
  "orderHistory": "Order History",
  "orderIdMissing": "Order ID is missing.",
  "orderPlacedSuccessfully": "Order placed successfully.",
  "orderType": "Order Type",
  "pair": "Pair",
  "pending": "Pending",
  "placeOrder": "Place Order",
  "placingOrder": "Placing Order...",
  "positionHistory": "Position History",
  "price": "Price",
  "processing": "Processing...",
  "quoteCurrency": "Quote Currency",
  "recentTrades": "Recent Trades",
  "searchMarket": "Search market...",
  "searchPair": "Search pair...",
  "searchPairSideStatus": "Search pair, side or status...",
  "searchTransactions": "Search transactions...",
  "selectPair": "Select Pair",
  "sell": "Sell",
  "sellExalt": "Sell EXALT",
  "sellShort": "Sell / Short",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "side": "Side",
  "slPrice": "SL Price",
  "spotMarkets": "Spot Markets",
  "spotTrading": "Spot Trading",
  "spotTradingSubtitle": "Professional Spot Trading Engine Powered by Exalt Exchange",
  "status": "Status",
  "stopLoss": "Stop Loss",
  "swapToExalt": "Swap To EXALT",
  "takeProfit": "Take Profit",
  "token": "Token",
  "total": "Total",
  "tpPrice": "TP Price",
  "tpSl": "TP/SL",
  "tradFi": "TradFi / CFD",
  "tradFiNoProvider": "No CFD/TradFi liquidity provider is connected yet.",
  "tradFiNoProviderDescription": "This module is provider-ready staging architecture. Forex, Metals, Indices, Stocks, and Crypto CFD instruments will appear here once a real broker/liquidity provider is connected and verified.",
  "tradFiStatusUnavailable": "Unable to load TradFi provider status right now.",
  "tradeHistory": "Trade History",
  "trades": "Trades",
  "tradingViewChart": "TradingView Chart",
  "transactionHistory": "Transaction History",
  "volume24h": "24H Volume",
  "walletConnected": "Wallet connected successfully.",
  "walletConnectionFailed": "Wallet connection failed.",
  "withdrawal": "Withdrawal",
  "withdrawals": "Withdrawals"
}